import { types } from '../types/types';

export const donutChartReducer = (state = {}, action ) => {
    switch ( action.type ) {
        case types.dataDonutChart:
            return{
                data: action.payload
            }     
        default:
            return state;
    }
}